import React from 'react';
import { NavigationButtonsProps } from '../types/components';

const NavigationButton = ({ prevTab, onConfirm, loading }: NavigationButtonsProps) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="bottom-btn">
                    <div className="field-btns">
                        <button
                            className="btn btn-prev prev_btn"
                            type="button"
                            onClick={prevTab ? prevTab : () => console.log('No hay prevTab')}
                        >
                            <i className="fas fa-arrow-left" /> Anterior
                        </button>
                        <button
                            className="btn btn-primary-admin next_btn"
                            type="button"
                            onClick={onConfirm}
                            disabled={loading}
                        >
                            {loading ? 'Guardando...' : 'Guardar y Enviar'} <i className="fas fa-arrow-right" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default NavigationButton;